import React from 'react'

import { cn } from './cn'

interface BrandEmphasisProps {
  children: React.ReactNode
  /**
   * `dark` (default) — text-primaryDark for headings on light backgrounds.
   * `bright` — text-primary for headings on dark or image backgrounds where
   * primaryDark reads too muted (e.g., the hero over the coast image).
   */
  variant?: 'dark' | 'bright'
  className?: string
}

/**
 * Inline brand-accented span. Wrap the emphasized fragment of a heading so
 * copy in content files reads naturally instead of being split into
 * `{prefix, emphasis}` objects:
 *
 *   heading: <>Trusted by <BrandEmphasis>Travelers Everywhere</BrandEmphasis></>
 *
 * Colors resolve from the active brand's snplay CSS variables, so shipsticks
 * (green), shipskis (blue), and shipplay (green) all pick up the correct hue
 * automatically.
 */
export const BrandEmphasis = ({
  children,
  variant = 'dark',
  className,
}: BrandEmphasisProps): React.ReactElement => {
  return (
    <span
      className={cn(
        variant === 'dark' && 'snplay:text-primaryDark',
        variant === 'bright' && 'snplay:text-primary',
        className,
      )}
    >
      {children}
    </span>
  )
}
